<template>
    <van-popup v-if="selectBusinessPopupShow " :value="selectBusinessPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="select_business_wrap" v-loading="loading">
            <div class="select_business_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                    <div class="checked_arr">
                        <van-checkbox icon-size="16px"    v-model="allChecked" @click="handleChangeAllCheck()" shape="square"><span>全选</span></van-checkbox>
                    </div>
                </div>
                <div class="search_wrap">
                    <van-search v-model="searchForm.keyword"  placeholder="请输入需要查询的内容"  @clear="handleClickSearch" @search="handleClickSearch">
                        <template #right-icon>
                            <i class="iconfont icon-rili" @click="calendarShow = true"></i>
                        </template>
                    </van-search>
                </div>
            </div>
            <div class="select_business_bottom">
                <van-checkbox-group  v-model="selectionIds">
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="item in  tableData">
                            <div class="select_business_check">
                                <van-checkbox icon-size="16px" :disabled="disabledData.find(find => find.project_id == item.project_id) ? true : false" :name="item.project_id" @click="handleChangeCheck(item)" shape="square"></van-checkbox>
                                <span class="link-label ellipsis" v-text="item.name"></span>
                            </div>
                            <div class="select_business_list">
                                <div class="user_head"  @click="handleClickUserDetail(item.salesperson)">
                                    <img :src=" item.salesperson_avatar ? item.salesperson_avatar : defaultImg" alt="" />
                                    <span v-text="item.salesperson_name"></span>
                                </div>
                                <div class="time" v-text="item.created_at.substring(0, 10)">  </div>
                            </div>
                        </li>
                    </ul>
                </van-checkbox-group>
            </div>

            <div class="select_business_btn">
                <van-button  @click="handleClickConfirm"  :disabled="BtnDisabled"  type="info" size="small" >确定</van-button>
            </div>

            <van-popup v-model="calendarShow" :close-on-click-overlay="true"  :style="{ height: '70vh',background:'#F7F8FA' }"  position="bottom"  round  @click-overlay="handleClickPopupRangeCalendarClose">
                <van-calendar  :allow-same-day="true" :max-date="dateCalendarMax" :min-date="dateCalendarMin" :default-date="defaultDate"	 :poppable="false"
                               :show-confirm="true" :show-title="false"  color="#1990FF" type="range" @confirm="handleClickRangeCalendarConfirm"></van-calendar>

            </van-popup>

            <userDetailDialog  v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow"  :userId="userDetailId" />

        </div>
    </van-popup>
</template>

<script>
import {getProjectList} from "@/api/index.js"
import {pagination} from '@/mixins'
import {formatDate} from "@/utils";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
export default {
    name: "select_business",
    components: {userDetailDialog},
    props: {
        selectBusinessPopupShow: {
            type: Boolean,
            default: false
        },
        pk_sort: {
            type: Object,
            default: ()=>{}
        },
        selectData:{
            type:Array,
            default:()=>[]
        },
        disabledData:{
            type:Array,
            default:()=>[]
        },
    },
    data() {
        return {
            defaultImg: require('@/assets/images/default.jpg'),
            loading:false,
            searchForm:{
                keyword:'',
                created_at:''
            },

            BtnDisabled:false,
            tableData:[],
            selectionIds:[], //选中的id
            multipleSelection:[],//选中的数据
            calendarShow:false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
            defaultDate:[],
            allChecked:false,
            userDetailPopupShow:false,
            userDetailId:0
        };
    },
    mixins: [pagination],
    created() {
        this.multipleSelection = JSON.parse(JSON.stringify(this.selectData))
        this.selectionIds = this.multipleSelection.map(item=>item.project_id)
        this.getTableData()
    },
    methods: {
        handleChangeAllCheck(){
            if(this.allChecked){
                this.selectionIds = this.tableData.filter(item => !this.disabledData.some(disabledItem => disabledItem.project_id === item.project_id)).map(item=>item.project_id)
                this.multipleSelection = JSON.parse(JSON.stringify(
                        this.tableData.filter(item => !this.disabledData.some(disabledItem => disabledItem.project_id === item.project_id))
                ))
            }else{
                this.selectionIds = []
                this.multipleSelection = []
            }
        },
        handleChangeCheck(item){
            if(this.selectionIds.includes(item.project_id)){
                this.multipleSelection.push(item)
            }else{
                this.multipleSelection.splice(this.multipleSelection.findIndex(item=>item.project_id == item.project_id),1)
            }
        },
        handleClickUserDetail(uid){
            this.userDetailId = uid
            this.userDetailPopupShow = true
        },
        handleClickSearch(){
            this.tableData = []
            this.pagination.pageNum = 1
            this.getTableData()
        },
        onLoadList(){
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.searchForm.keyword,
                created_at:this.searchForm.created_at,
                pk_sort:this.pk_sort
            }
            getProjectList(postData).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    data.forEach(item=>{
                        this.$set(item,'project_name',item.name)
                    })
                    this.pagination.total = total
                    this.tableData =  this.tableData.concat(data)
                    this.pagination.pageNum++;
                }
                this.loading = false
            })
        },
        // 选择日期
        handleClickRangeCalendarConfirm(range){
            const [start, end] = range
            let value = [formatDate(start, 'date'), formatDate(end, 'date')]
            this.searchForm.created_at = value
            this.calendarShow = false
            this.handleClickSearch()
        },
        // 取消选择日期
        handleClickPopupRangeCalendarClose(){

        },
        //点击查看关联客户详情
        handleClickCompanyDetail(item) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: item.customer_id,
                    name: item.customer_name,
                },
            });
        },
        handleClickConfirm() {
            this.$emit('success',this.multipleSelection)
            this.$emit("update:selectBusinessPopupShow", false)
        },
        handleClickClose(){
            this.$emit("update:selectBusinessPopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>